export default function SupporterIcon(){
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9832 17.1504V15.3171C18.9832 13.6085 17.8147 12.1729 16.2332 11.7659M13.0249 0.916919C14.3687 1.46086 15.3166 2.77826 15.3166 4.31706C15.3166 5.85586 14.3687 7.17326 13.0249 7.7172M14.3999 17.1504C14.3999 15.4419 14.3999 14.5877 14.1208 13.9139C13.7486 13.0154 13.0348 12.3016 12.1364 11.9295C11.4626 11.6504 10.6084 11.6504 8.8999 11.6504H6.1499C4.44145 11.6504 3.58722 11.6504 2.9134 11.9295C2.01496 12.3016 1.30116 13.0154 0.929011 13.9139C0.649902 14.5877 0.649902 15.4419 0.649902 17.1504M11.1916 4.31706C11.1916 6.3421 9.54995 7.98372 7.5249 7.98372C5.49986 7.98372 3.85824 6.3421 3.85824 4.31706C3.85824 2.29201 5.49986 0.650391 7.5249 0.650391C9.54995 0.650391 11.1916 2.29201 11.1916 4.31706Z"
        stroke="#656565"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}